module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1100px",
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("点击下载SDK说明文档")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 16
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "min-width": "40px"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("新增")])], 1)])], 1), _vm._v(" "), _c('el-timeline', [_vm._l((_vm.list), function(v, i) {
    return _c('el-timeline-item', {
      key: i,
      attrs: {
        "placement": "top",
        "size": "large",
        "icon": "el-icon-time"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          return _vm.edit(v)
        }
      }
    }, [_c('el-card', {
      staticStyle: {
        "max-width": "500px"
      }
    }, [_c('h4', [_vm._v("SDK " + _vm._s(v.version))]), _vm._v(" "), _c('p', [_vm._v("更新时间:" + _vm._s(v.update_time))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(v.content))])])], 1)])
  }), _vm._v(" "), _c('el-timeline-item', {
    attrs: {
      "placement": "top"
    }
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增版本' : '编辑版本',
      "visible": _vm.addDialog,
      "width": "500px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "SDK版本号",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入SDK版本号",
      "clearable": ""
    },
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SDK更新内容",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入SDK更新内容",
      "clearable": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAdd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14e9c656"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sdkControl/sdkInfo.vue
// module id = 1089
// module chunks = 2